<a class="storyblok-link" href="{{href}}" target="{{target}}" title="{{title}}" [ngClass]="classList" [style.color]="color">
    {{title}}
</a>